import $ from 'jquery';

export default class StDropDown {
  init(){
    $('body').on({
        mouseenter: function () {
            $(this).addClass('open').trigger($.Event('st.dropdown.shown', this));
        },
        mouseleave: function () {
            $(this).removeClass('open');
        }
    }, ".dropdown_wrap");
  }
}



// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js


// WEBPACK FOOTER //
// ./js/components/st-drop-down.js